// Per-org custom team logos. A tiny external store so every <TeamBadge> re-renders
// once the org's uploaded/linked crests arrive (replacing the default stylised SVG).
import { useSyncExternalStore } from "react";
import api from "@/lib/api";

const STOP = new Set(["f", "femminile", "women", "womens", "calcio", "fc", "acf", "ssd", "asd", "as", "ac", "us", "ssc"]);

export const teamLogoKey = (n) =>
  (n || "").toLowerCase().replace(/[^a-z0-9 ]/g, " ").split(/\s+/).filter((t) => t && !STOP.has(t)).join("");

const abs = (u) => (u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u || "");

let _map = {};
let _loaded = false;
let _loading = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

export function loadTeamLogos(force = false) {
  if (_loading || (_loaded && !force)) return;
  _loading = true;
  api.get("/team-logos")
    .then((r) => {
      const m = {};
      (r.data?.logos || []).forEach((l) => { if (l.key && l.logo_url) m[l.key] = abs(l.logo_url); });
      _map = m; _loaded = true; _loading = false; emit();
    })
    .catch(() => { _loading = false; });
}

export function teamLogoUrl(name) { return _map[teamLogoKey(name)] || null; }

// Clear the per-org cache on login/logout so one org's crests never show for another.
export function resetTeamLogos() { _map = {}; _loaded = false; _loading = false; emit(); }

export function useTeamLogos() {
  return useSyncExternalStore(
    (cb) => { subs.add(cb); loadTeamLogos(); return () => subs.delete(cb); },
    () => _map,
    () => _map,
  );
}
